import { ApiError } from '@/lib/api/errors';

import { AUTH_ERROR_CODES } from './constants';

export const AUTH_ERROR_COPY: Record<string, string> = {
  [AUTH_ERROR_CODES.INVALID_CREDENTIALS]: 'Invalid phone number or password',
  [AUTH_ERROR_CODES.ACCOUNT_TEMPORARILY_LOCKED]:
    'Account temporarily locked. Try again after 30 minutes.',
  [AUTH_ERROR_CODES.RATE_LIMIT_EXCEEDED]: 'Too many attempts. Please try again later.',
  [AUTH_ERROR_CODES.INVALID_OTP]: 'Please enter a valid code',
  [AUTH_ERROR_CODES.SESSION_EXPIRED]: 'Your session has expired. Please log in again.',
  [AUTH_ERROR_CODES.RESEND_COOLDOWN_ACTIVE]:
    'Please wait for the countdown to finish before requesting another OTP.',
  [AUTH_ERROR_CODES.INVALID_PHONE_NUMBER]: 'Enter a valid 10-digit US phone number.',
  [AUTH_ERROR_CODES.CUSTOMER_NOT_FOUND]: 'This number is not registered',
  [AUTH_ERROR_CODES.PHONE_NOT_REGISTERED]: 'This number is not registered',
  [AUTH_ERROR_CODES.ACCOUNT_DEACTIVATED]: 'Your account is inactive. Please contact support.',
  [AUTH_ERROR_CODES.INVALID_REFRESH_TOKEN]: 'Your session has expired. Please log in again.',
  [AUTH_ERROR_CODES.RESET_TOKEN_EXPIRED]:
    'Your verification session has expired. Please start again.',
  [AUTH_ERROR_CODES.PASSWORD_REUSED]: 'New password cannot be the same as your previous password.',
};

const GENERIC = 'Something went wrong. Please try again.';

export function authErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.message) return error.message;
    if (error.code && AUTH_ERROR_COPY[error.code]) return AUTH_ERROR_COPY[error.code];
    return GENERIC;
  }
  return GENERIC;
}
